module.exports = __webpack_public_path__ + "ee147b5a735653fc8edbc84941079e78.svg";